import { sleepForMinTime } from 'ihunter-common';
import { ref } from 'vue';

const isLoading = ref(false);
const MIN_LOADING_IME_MS = 500;

export function useLoadingState() {
    async function doLoadingOperation(operationFn, ...args) {
        try {
            isLoading.value = true;
            const result = await sleepForMinTime(operationFn(...args), MIN_LOADING_IME_MS);
            isLoading.value = false;
            return result;
        } catch (error) {
            isLoading.value = false;
            throw error;
        }
    }

    return {
        isLoading,
        doLoadingOperation,
    };
}
